
import { defineComponent, ref, PropType, computed, nextTick, watch, getCurrentInstance } from 'vue'
import { KpiSchemeActionId, WorkingFormatKpiSetting } from '@/types/GCB2'
import BaseInputOutlined from '../../../../../inputs/BaseInputOutlined.vue'
import { v4 as uuidv4 } from 'uuid'

export default defineComponent({
    name: 'KpiStaffActionsConvertions',
    components: { BaseInputOutlined },
    props: {
        value: {
            type: Object as PropType<WorkingFormatKpiSetting['scheme']['visit_value']>,
            required: true,
        },
        selectedCategoryId: { type: String as PropType<string>, required: true },
    },
    setup(props, { emit,  }) {
        const root = getCurrentInstance()!.proxy
        const conversions = computed<any>({
            get() {
                return props.value[props.selectedCategoryId]
            },
            set(newValue) {
                emit('input', Object.assign({}, props.value, { [props.selectedCategoryId]: newValue }))
            },
        })
        const activeConversion = ref(conversions.value[0])
        watch(
            activeConversion,
            () => {
                emit('select', activeConversion.value)
            },
            { immediate: true }
        )
        watch(
            () => props.selectedCategoryId,
            () => {
                activeConversion.value = conversions.value[0]
            }
        )

        const sortConvertions = () => {
            conversions.value = conversions.value.sort((a: any, b: any) => {
                if (a.conversion.trim() === '') {
                    return 1
                }
                if (b.conversion.trim() === '') {
                    return -1
                }

                return parseFloat(a.conversion) - parseFloat(b.conversion)
            })
        }

        const onConversionBlur = (event: Event, conversion: any) => {
            const otherConversions = conversions.value.filter((el: any) => el.id !== conversion.id)
            const otherConversionsValues = otherConversions.map((el: any) => el.conversion)
            if (
                otherConversionsValues.includes(String(conversion.conversion)) ||
                String(conversion.conversion).trim() === ''
            ) {
                conversion.conversion = ''
                const target = event.target as HTMLInputElement
                target.classList.remove('conversion-input-error')
            }

            sortConvertions()
        }
        const onConversionInput = (event: Event, conversion: any) => {
            const otherConversions = conversions.value.filter((el: any) => el.id !== conversion.id)
            const otherConversionsValues = otherConversions.map((el: any) => el.conversion)
            const target = event.target as HTMLInputElement
            const val = target.value

            if (otherConversionsValues.includes(String(val))) {
                target.classList.add('conversion-input-error')
            } else {
                target.classList.remove('conversion-input-error')
            }
        }
        const updateConversion = (event: Event, conversion: any) => {
            const target = event.target as HTMLInputElement
            const val = target.value
            conversion.conversion = val
        }
        const addConversion = () => {
            const newConversion = {
                id: uuidv4(),
                conversion: '',
                values: [
                    {
                        id: uuidv4(),
                        activationId: 'default',
                        fixed: 0,
                        percent: 0,
                    },
                ],
            }
            conversions.value.push(newConversion)
            const refName = `staffActionConversionInput-${newConversion.id}`
            activeConversion.value = newConversion

            nextTick(() => {
                ;(root.$refs as any)[refName][0].focus()
            })
        }
        const deleteConversion = (conversion: any) => {
            const delIndex = conversions.value.findIndex((el: any) => el.id === conversion.id)
            conversions.value = conversions.value.filter((el: any) => el.id !== conversion.id)
            if (activeConversion.value.id === conversion.id) {
                activeConversion.value = conversions.value[delIndex - 1]
            }
        }

        const onCreated = () => {
            sortConvertions()
        }
        onCreated()

        return {
            conversions,
            activeConversion,
            updateConversion,
            onConversionBlur,
            onConversionInput,
            addConversion,
            deleteConversion,
        }
    },
})
